import React from 'react'
import { BoardContext } from './types'

export default React.createContext<BoardContext>({
  id: 0
})